import { createContext, useState } from 'react';
import Api from '../Api/Auth';

const Context = createContext();
function UserHOC ({ children }) {
	const [user, setUser] = useState(() => window.INITIAL_DATA.user);

	async function logIn ({ username, password, token }) {
		const result = await Api.login({
			username, password, token
		});
		if (result.status) {
			setUser(result.user);
			return result;
		}
		if (result.requiredTotp) {
			return {
				user: result.user,
				status: false,
				requiredTotp: true
			};
		}
		const err = new Error(result.message);
		err.body = result;
		throw err;
	}

	async function logOut () {
		await Api.logOut();
		setUser(null);
	}

	return (
		<Context.Provider value={{
			user,
			logIn,
			logOut,
			setUser,
			beginSSO: () => Api.beginSSO()
		}}
		>
			{children}
		</Context.Provider>
	);
}

export default Context;
export {
	Context as UserContext,
	UserHOC
};
